import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_84: FaireProductEntity = {
  token: "catalog_prod_prod-84",
  type: "product",
  name: "Serving Piece",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 27.1,
  msrpDollars: 67.75,
  sku: "AN0084",
  caseSize: 6,
  material: "Metal",
  collectionToken: "col_andean-touch",
  categoryTokens: ["catalog_cat_dogs"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 169,
  description: "Beautiful Andean Touch piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
